var isString;

isString = require("./_helpers").isString;

module.exports = {
  _name: "parseElement",
  _v: 1,
  _rebind: "$parseElement",
  methods: {
    $parseElement: {
      byObj: function(o) {
        return o.el = this.$parseElement.byString(o.el);
      },
      byString: function(el) {
        var ell;
        if (isString(el)) {
          ell = el === "this" ? this : this[el];
          if(process.env.NODE_ENV!=='production' && ell == null){throw new Error('element ' + el + ' not found')};
          return ell;
        } else if (el != null) {
          return el;
        } else {
          return this;
        }
      }
    }
  }
};

;



//////////////////
// WEBPACK FOOTER
// /home/peaul/ceri/ceri/lib/parseElement.js
// module id = 8
// module chunks = 1